import useEmblaCarousel, { UseEmblaCarouselType } from "embla-carousel-react"
import { useCallback, useEffect, useState } from "react"

export { useEmblaCarousel }
export const usePrevNextButtons = (emblaApi: UseEmblaCarouselType[1] | undefined) => {
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

    const onPrevButtonClick = useCallback(() => {
        if (!emblaApi) return
        emblaApi.scrollPrev()
    }, [emblaApi])

    const onNextButtonClick = useCallback(() => {
        if (!emblaApi) return
        emblaApi.scrollNext()
    }, [emblaApi])

    const onSelect = useCallback((emblaApi: UseEmblaCarouselType[1]) => {
        setPrevBtnDisabled(!emblaApi?.canScrollPrev())
        setNextBtnDisabled(!emblaApi?.canScrollNext())
        setSelectedIndex(emblaApi?.selectedScrollSnap() || 0)
    }, [])
    const onDotButtonClick = useCallback(
        (index: number) => {
            if (!emblaApi) return
            emblaApi.scrollTo(index)
            setSelectedIndex(index)
        },
        [emblaApi]
    )
    useEffect(() => {
        if (!emblaApi) return

        onSelect(emblaApi)
        emblaApi.on("reInit", onSelect)
        emblaApi.on("select", onSelect)
    }, [emblaApi, onSelect])

    return {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
        selectedIndex,
        onDotButtonClick,
    }
}
